$(document).ready(function() {

    storeAffiliateCode();

    var freelancerSlider = $(".freelancers-slider");

    if (freelancerSlider.length) {
        freelancerSlider.slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            lazyLoad: "ondemand",
            dots: true,
            infinite: true,
            prevArrow: freelancerSlider.closest(".slider-wrapper").find(".slider-arrows .prev"),
            nextArrow: freelancerSlider.closest(".slider-wrapper").find(".slider-arrows .next"),
            dotsClass: "slick-dots custom-dots",
            
            responsive: [
                {
                    breakpoint: 991.98,
                    settings: { 
                        slidesToShow: 2, 
                        slidesToScroll: 2 
                    }
                },
                {
                    breakpoint: 575.98,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    };

    var testimonialsSlider = $(".testimonials-slider");

    if (testimonialsSlider.length) {
        testimonialsSlider.slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            lazyLoad: "ondemand",
            dots: true,
            infinite: true,
            prevArrow: testimonialsSlider.closest(".slider-wrapper").find(".slider-arrows .prev"),
            nextArrow: testimonialsSlider.closest(".slider-wrapper").find(".slider-arrows .next"),
            dotsClass: "slick-dots custom-dots",
            
            responsive: [
                {
                    breakpoint: 991.98,
                    settings: { 
                        slidesToShow: 2, 
                        slidesToScroll: 2 
                    }
                },
                {
                    breakpoint: 575.98,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    };
});

/**
 * Locally stores the affiliate code using LocalStorage.
 */
function storeAffiliateCode() {
    const affParams = ['aff', 'aff_id'];
    let affiliateID = null;
    let storedParam = null;
  
    // Check if any of the affiliate params are already in localStorage
    for (let param of affParams) {
        affiliateID = window.localStorage.getItem(param);
        if (affiliateID !== null) {
            storedParam = param;
            break;
        }
    }

    // If no affiliate ID is stored, check the URL for either param
    if (affiliateID === null) {
        for (let param of affParams) {
            affiliateID = getURLParam(param);
            if (affiliateID != null) {
            window.localStorage.setItem(param, affiliateID);
            storedParam = param;
            break;
            }
        }
    }
  
    if (affiliateID != null && storedParam != null) {
      addAffiliateCode(storedParam, affiliateID);
    }
  }

  /**
  * Get the value of a URL parameter.
  */
  function getURLParam(name) {
    const url = new URL(window.location.href);
    return url.searchParams.get(name);
  }
  
  /**
   * Add the affiliate code to links inside containers with class "add-affiliate-code".
   */
  function addAffiliateCode(param, affiliateID) {
    // Process all links pointing to app.theurbanwriters.com
    const links = document.querySelectorAll("a[href^='https://app.theurbanwriters.com']");

    links.forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set(param, affiliateID);
        link.href = url.toString();
    });
  }
